import { Lock } from "lucide-react";
import type { VisitorProfileField } from "@/lib/graphql/queries/generated/profile.generated";
import { FieldControl } from "./field-controls";
import { localizeFieldLabel } from "./system-field-labels";

/**
 * One row in the identity form. Renders the per-type control, a
 * required `*`, a lock icon for pinned rows, and an inline error
 * message under the control (set by the parent on either client-side
 * validation failure or BE-returned `peopleFields.invalidValue`).
 */
export function FieldRow({
  field,
  value,
  onChange,
  error,
  t,
}: {
  field: VisitorProfileField;
  value: string | null;
  onChange: (next: string | null) => void;
  error?: string;
  t: (key: string) => string;
}) {
  const pinned = field.pinned;
  const id = `wx-profile-${field.key}`;
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="flex items-baseline justify-between gap-2 text-xs font-medium text-wx-fg-muted"
      >
        <span className="inline-flex items-center gap-1">
          {localizeFieldLabel(field.key, field.label, t)}
          {field.required && (
            <span className="text-wx-danger" title={t("requiredHint")}>
              *<span className="sr-only">{t("requiredHint")}</span>
            </span>
          )}
          {pinned && <Lock size={11} aria-hidden="true" className="text-wx-fg-subtle" />}
        </span>
        {pinned && (
          <span className="text-[10px] font-normal text-wx-fg-subtle">{t("pinnedHint")}</span>
        )}
      </label>
      <FieldControl id={id} field={field} value={value} onChange={onChange} t={t} />
      {error && <p className="text-[11px] text-wx-danger">{error}</p>}
    </div>
  );
}
